import { insertRegex, findDotPathToId } from './applyPatch';

export const resetEmptyPatchProperties =
  (content: Content, resetPath: (path: string) => unknown) =>
  ([key, [patch]]: [string, Patch]) => {
    // do not attempt to reset any advanced patched screens (there is no original content to reset to)
    if (insertRegex.test(key)) return null;

    // reset shorthand props if they are empty strings
    if ((key.startsWith('$') || key.startsWith('#')) && 'value' in patch) {
      if (typeof patch.value === 'string') {
        const propName = key.slice(1).split('.').pop() || '';

        // console.log('checking', key, propName, patch.value);

        // only reset empty strings for specific properties to avoid resetting things like $course.logo: ''
        if (
          propName === 'text' ||
          propName === 'title' ||
          propName === 'heading' ||
          propName === 'subheading' ||
          propName === 'instructions'
        ) {
          // trim and remove any remaining heading markdown
          let text = patch.value.trim().replace(/#+\s*/g, '');

          if (text.length === 0) {
            resetPath(key);
          }
        }
      }
      return;
    }

    const keyPath = findDotPathToId(content, key);
    if (!keyPath) return;

    // iterate over each property in the patches object
    const recurse = (keyPath, obj: any) => {
      for (const prop in obj) {
        const propPath = `${keyPath}.${prop}`;
        if (obj.hasOwnProperty(prop)) {
          // recurse over object and arrays
          if (
            typeof obj[prop] === 'object' ||
            (Array.isArray(obj[prop]) && obj[prop] !== null)
          ) {
            recurse(propPath, obj[prop]);
          } else {
            // reset empty strings to original value
            if (typeof obj[prop] === 'string') {
              // console.log('checking', propPath, prop, obj[prop]);

              // only reset empty strings for specific properties to avoid resetting things like $course.logo: ''
              if (
                prop === 'text' ||
                prop === 'title' ||
                prop === 'heading' ||
                prop === 'subheading' ||
                prop === 'instructions'
              ) {
                if (obj[prop].trim().length === 0) {
                  resetPath(propPath);
                }
              }
            }
          }
        }
      }
    };

    recurse(keyPath, patch);
  };
